import { buildModelManager } from "../builder.js";
const DefaultSimioMigrationSelection = {
  __typename: true,
  id: true,
  batchNumber: true,
  contactsRetrieved: true,
  createdAt: true,
  currentStep: true,
  cursor: true,
  customerId: true,
  endDate: true,
  endRecord: true,
  errorMessage: true,
  gadgetJobId: true,
  report: true,
  simioServerUrl: true,
  startDate: true,
  startRecord: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "simioMigration";
const pluralModelApiIdentifier = "simioMigrations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSimioMigrationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSimioMigrationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSimioMigrationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSimioMigrationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSimioMigrationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSimioMigrationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSimioMigrationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createSimioMigration",
    operationReturnType: "CreateSimioMigration",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      simioMigration: { required: false, type: "CreateSimioMigrationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSimioMigrationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateSimioMigrations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateSimioMigrationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSimioMigrationSelection
  },
  {
    type: "action",
    operationName: "updateSimioMigration",
    operationReturnType: "UpdateSimioMigration",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      simioMigration: { required: false, type: "UpdateSimioMigrationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSimioMigrationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateSimioMigrations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateSimioMigrationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSimioMigrationSelection
  },
  {
    type: "action",
    operationName: "deleteSimioMigration",
    operationReturnType: "DeleteSimioMigration",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteSimioMigrations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertSimioMigration",
    operationReturnType: "UpsertSimioMigration",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      simioMigration: { required: false, type: "UpsertSimioMigrationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateSimioMigrationResult": { hasReturnType: false },
      "... on UpdateSimioMigrationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSimioMigrationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertSimioMigrations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertSimioMigrationsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultSimioMigrationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "simioMigrationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const SimioMigrationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSimioMigrationSelection,
  operations
);
export {
  DefaultSimioMigrationSelection,
  SimioMigrationManager
};
//# sourceMappingURL=SimioMigration.js.map
